import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";

interface AddCreditsInitialState {
  isAddCreditsLoading: boolean;
}

const initialState: AddCreditsInitialState = {
  isAddCreditsLoading: false,
};

export const purchaseAddCredits = createSlice({
  name: "purchaseAddCredits",
  initialState,
  reducers: {
    setAddCreditsLoading: (state, action: PayloadAction<boolean>) => {
      state.isAddCreditsLoading = action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.addCredits.purchaseAddCredits;

export const selectAddCreditsIsLoading = createSelector(
  selector,
  (s) => s.isAddCreditsLoading
);

export const { setAddCreditsLoading } = purchaseAddCredits.actions;

export default purchaseAddCredits.reducer;
